import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { SmartMarkdownLink } from 'components';

/**
 * Standalone, no-chrome help page for the Markdown supported in announcements.
 * Reached at /markdown-tips (see App.js, which renders this bypassing the login
 * chrome and the app shell — same pattern as the OAuth consent page). The
 * content is an editable Markdown file served from src/static/markdown-tips.md,
 * rendered with the same react-markdown + remark-gfm used to render the notes.
 */
const MarkdownTipsRoot = () => {
  const [text, setText] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    document.title = 'Markdown Tips for Announcements';
    fetch('/markdown-tips.md')
      .then((r) => {
        if (!r.ok) throw new Error('not found');
        return r.text();
      })
      .then(setText)
      .catch(() => setError(true));
  }, []);

  return (
    <div
      style={{
        maxWidth: 780,
        margin: '0 auto',
        padding: '32px 24px 64px',
        fontFamily: 'Helvetica, Arial, sans-serif',
        color: '#222222',
        lineHeight: 1.6,
      }}
    >
      <style>{`
        .md-tips h1 { color: #1565c0; margin-bottom: 8px; }
        .md-tips h2 { color: #1565c0; margin-top: 28px; border-bottom: 1px solid #eaeef3; padding-bottom: 4px; }
        .md-tips code { background: #f2f4f7; padding: 2px 5px; border-radius: 3px; font-size: 0.9em; }
        .md-tips pre { background: #f6f8fa; padding: 12px 14px; border-radius: 6px; overflow: auto; }
        .md-tips pre code { background: none; padding: 0; }
        .md-tips table { border-collapse: collapse; margin: 8px 0; }
        .md-tips th, .md-tips td { border: 1px solid #c9d4e2; padding: 6px 12px; }
        .md-tips th { background: #f4f7fb; }
        .md-tips a { color: #1565c0; }
        .md-tips blockquote { margin: 8px 0; padding: 4px 14px; border-left: 4px solid #c9d4e2; color: #555; }
        .md-tips hr { border: none; border-top: 1px solid #dfe4ea; margin: 24px 0; }
      `}</style>
      {error ? (
        <p>Sorry, the Markdown tips could not be loaded.</p>
      ) : (
        <div className='md-tips'>
          <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ a: SmartMarkdownLink }}>{text}</ReactMarkdown>
        </div>
      )}
    </div>
  );
};

export { MarkdownTipsRoot };
export default MarkdownTipsRoot;
